import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const QuizAlertModal = ({
  open,
  onClose,
  description,
  subText,
  onYes,
  onNo,
  loading = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "90%" : 500,
    maxWidth: "95%",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: isMobile ? 2 : 3,
  };

  return (
    <Modal open={open} onClose={() => !loading && onClose()}>
      <Box sx={style}>
        {/* Description */}
        <Typography
          gutterBottom
          sx={{
            fontSize: isMobile ? "14px" : "16px",
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>

        {/* Sub text */}
        {subText && (
          <Typography
            sx={{
              mb: 2,
              fontSize: isMobile ? "13px" : "14px",
              color: "text.secondary",
            }}
          >
            {subText}
          </Typography>
        )}

        {/* Buttons (ALWAYS ROW) */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            color="success"
            onClick={onYes}
            disabled={loading}
            sx={{
              flex: 1,
              fontSize: isMobile ? "13px" : "14px",
              py: isMobile ? 0.8 : 1,
            }}
          >
            Yes
            {loading && (
              <span className="spinner-border spinner-border-sm ms-2"></span>
            )}
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={onNo}
            disabled={loading}
            sx={{
              flex: 1,
              fontSize: isMobile ? "13px" : "14px",
              py: isMobile ? 0.8 : 1,
            }}
          >
            No
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default QuizAlertModal;